import { isValidIP } from '@/utils/valid-ip.js';

// 从 IPAPI.is 获取 IPv6 地址
const getIPFromIPAPIIS_V6 = async (originalSite) => {
    try {
        // IPAPI.is provides a simple endpoint that returns just the IP
        const response = await fetch("https://api.ipapi.is/");
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }

        const data = await response.json();
        const ip = data.ip;
        const source = "IPAPI.is IPv6";
        
        if (isValidIP(ip)) {
            return {
                ip: ip,
                source: source
            };
        } else {
            console.error("Invalid IP from IPAPI.is:", ip);
            return {
                ip: null,
                source: source
            };
        }
    } catch (error) {
        console.error("Error fetching IP from IPAPI.is:", error);
        return {
            ip: null,
            source: "IPAPI.is IPv6"
        };
    }
};

export { getIPFromIPAPIIS_V6 };
